<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="addFileFlag" :title="editForm.editFlag ? '编辑附件' : '新增附件'" width="55%" class="exceptDialog">
      <template v-slot:content>
        <div class="mainForm">
          <el-form ref="form" :model="editForm" :rules="rules">
            <el-form-item label="请设置上传附件名称：" prop="filename">
              <el-input v-model="editForm.filename" placeholder="请输入附件名称"></el-input>
            </el-form-item>
            <el-form-item label="请设置上传附件格式：" prop="fileExtList">
              <el-checkbox label="PDF" v-model="editForm.fileType1"></el-checkbox>
              <el-checkbox label="图片" v-model="editForm.fileType2"></el-checkbox>
              <el-checkbox label="WORD" v-model="editForm.fileType3"></el-checkbox>
            </el-form-item>
            <el-form-item label="请设置上传附件说明：">
              <el-input v-model="editForm.fileRemark" placeholder="请输入附件说明"></el-input>
            </el-form-item>
            <el-form-item label="是否必填：" >
              <el-switch v-model="editForm.required" :active-value="1" :inactive-value="0"></el-switch>
              <span class="machineTip" v-show="editForm.examType=='100'">(机房断网模式使用OIS签到)</span>
            </el-form-item>
            <el-form-item label="请设置上传附件大小：" prop="filesize">
              <el-input v-model="editForm.filesize" placeholder="10" class="shortInput"></el-input> M <font color="#ccc">（最大10M）</font>
            </el-form-item>
            <el-form-item label="请上传图例：">
                <el-upload
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadImg">
                <img v-if="editForm.sampleUrl" :src="editForm.sampleUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="请上传模板：" class="upload-template-item">
                <el-upload
                class="upload-demo"
                action=""
                :show-file-list="false"
                :before-upload="handleChange"
                :http-request="uploadImg">
                <el-button size="small" type="primary">点击上传模板</el-button>
                <div slot="tip" class="el-upload__tip">（可上传 PDF / WORD / EXCEL 格式模板）</div>
                </el-upload>
                <div class="fileListContent" v-if="editForm.templateUrl">
                    <a :download="editForm.templateName" :href="editForm.templateUrl" target="_blank">{{ editForm.templateName }}</a>
                </div>
            </el-form-item>
            <el-form-item label="请选择检测智能体：">
              <el-select v-model="editForm.agentCode" placeholder="请选择检测智能体" clearable>
                <el-option
                  v-for="item in agentList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="addFileFlag = false">取消</el-button>
        <el-button round @click="uploadSubmit" type="primary">提交</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import {
  planFileAgentListFn,
  planFileSetAddFn,
  planFileSetModifyFn,
  planFileSetListFn,
  planFileSetDeleteFn,
  planFileSetSampleTemplateFn,
  planFileSetModifyRequiredFn
} from "@/http/modules/examSet/examBatch";

export default {
  name: "addUpload",
  data() {
    return {
      planId: this.$route.query.planId,
      agentList: [],
      pagination: {
        total: 0,
      },
      mainTopBtnList: [
        {
          title: "新增附件",
          fn: this.addFileDialog,
        },
      ],
      addFileFlag: false,
      tableData: [],
      tableHeader: [
        {
          title: "上传附件名称",
          prop: "filename",
        },
        {
          title: "上传附件格式",
          prop: "fileext",
        },
        {
          title: "上传附件说明",
          prop: "fileRemark",
        },
        {
          title: "上传附件大小",
          prop: "fileSizeName",
        },
        {
          title: "是否必填",
          prop:"required",
          type:"switch",
          switchChange:this.changeUploadState
        },
        {
          title: "图例",
          type: 'button',
          prop: "sampleUrl",
          formatter: (val) => val.row.sampleUrl ? '图例' : '--',
          disableFn: (val) => val.row.sampleUrl ? false : true,
          click: this.showSampleUrl
        },
        {
          title: "模板",
          type: 'button',
          prop: "templateUrl",
          formatter: (val) => val.row.templateUrl ? '模板' : '--',
          disableFn: (val) => val.row.templateUrl ? false : true,
          click: this.showTemplateUrl
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              click: this.editUpload,
            },
            {
              title: "删除",
              click: this.deleteUpload,
            },
          ],
        },
      ],
      defaultPicType: [
        {
          id: 'PDF',
          name: 'PDF'
        },
        {
          id: 'PIC',
          name: '图片'
        },
        {
          id: 'Word',
          name: 'Word'
        }
      ],
      editForm: {
        editFlag: false,
        id: '',
        planId: '',
        filename: '',
        fileType1: false,
        fileType2: false,
        fileType3: false,
        fileRemark: '',
        required: '',
        filesize: '',
        sampleUrl: '',
        templateUrl: '',
        templateName: '',
        agentCode: '',
      },
      rules: {
        filename: [
          { required: true, message: '请输入上传附件名称', trigger: 'blur' }
        ],
        fileExtList: [
          { required: true, message: '请设置上传附件大小', trigger: 'blur' }
        ],
        filesize: [
          { required: true, message: '请设置上传附件大小', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.getList();
    this.getAgentList();
  },
  methods: {
    async getList() {
      const { code,data } = await planFileSetListFn({ planId: this.planId });
      if(code){
        data.forEach(item => {
          let fileExtType = '';
          let fileExtList = item.fileext.toLowerCase().split(',');
          if(fileExtList.includes('pdf')){
            fileExtType += 'PDF,';
          }
          if(fileExtList.includes('jpg') || fileExtList.includes('jpeg') || fileExtList.includes('png')){
            fileExtType += '图片,';
          }
          if(fileExtList.includes('doc') || fileExtList.includes('docx')){
            fileExtType += 'Word,';
          }
          item.fileext = fileExtType.slice(0, -1);
          item.fileRemark = item.fileRemark.replace(',', '/');
          item.fileSizeName = '<=' + (item.filesize/1024) + 'M';
        });
        this.tableData = data;
      }
    },
    async getAgentList() {
      const { code, data } = await planFileAgentListFn();
      if(code === 1 && data) {
        this.agentList = data;
      }
    },
    addFileDialog() {
      this.editForm.editFlag = false;
      this.editForm.id = '';
      this.editForm.planId = '';
      this.editForm.filename = '';
      this.editForm.fileType1 = false;
      this.editForm.fileType2 = false;
      this.editForm.fileType3 = false;
      this.editForm.fileRemark = '';
      this.editForm.required = '';
      this.editForm.filesize = '';
      this.editForm.sampleUrl = '';
      this.editForm.templateUrl = '';
      this.editForm.templateName = '';
      this.editForm.agentCode = '-1';
      this.addFileFlag = true;
    },
    async changeUploadState(row) {
      await planFileSetModifyRequiredFn({ id: row.id, required: row.required ? 1 : 0 });
    },
    async editUpload(row){
      this.editForm.editFlag = true;
      this.editForm.id = row.id;
      this.editForm.planId = row.planId;
      this.editForm.filename = row.filename;
      this.editForm.fileType1 = row.fileext.includes('PDF');
      this.editForm.fileType2 = row.fileext.includes('图片');
      this.editForm.fileType3 = row.fileext.includes('Word');
      this.editForm.fileRemark = row.fileRemark;
      this.editForm.required = row.required;
      this.editForm.filesize = row.filesize / 1024;
      this.editForm.sampleUrl = row.sampleUrl;
      this.editForm.templateUrl = row.templateUrl;
      this.editForm.templateName = row.templateUrl ? row.templateUrl.split('/')[row.templateUrl.split('/').length - 1] : '';
      // 根据 agentList 匹配 agentCode，确保值类型一致，避免 el-select 直接显示原始值
      if (row.agentCode) {
        const found = this.agentList.find(item => String(item.code) === String(row.agentCode));
        this.editForm.agentCode = found ? found.code : '';
      } else {
        this.editForm.agentCode = '';
      }
      this.addFileFlag = true;
    },
    async deleteUpload(row){
      this.$confirm("确定要删除该条数据吗？", "提示", {
        type: "warning",
      }).then(() => {
        planFileSetDeleteFn({ id: row.id, }).then((res) => {
          if(res.code === 1){
            this.$message.success('删除成功');
            this.getList();
          }
        });
      }).catch(() => {});
    },
    async beforeAvatarUpload(file) {
      const defaultType = ['image/png', 'image/jpeg', 'image/png'];
      const isPic = defaultType.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isPic) {
        this.$message.error('上传图片只能是 JPG/JPEG/PNG 格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }
      const fd = new FormData();
      fd.append('file', file);
      const {code,data} = await planFileSetSampleTemplateFn(fd);
      if(code === 1){
        this.editForm.sampleUrl = data;
      }
    },
    uploadImg(){

    },
    async handleChange(file){
      let fileType = file.name.split('.')[1];
      const defaultType = ['doc', 'docx', 'pdf', 'xls', 'xlsx'];
      const isAllow = defaultType.includes(fileType);
      const isLt5M = file.size / 1024 / 1024 < 2;

      if (!isAllow) {
        this.$message.error('上传文件只能是 word、pdf、excel 格式!');
        return;
      }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return;
      }
      const fd = new FormData();
      fd.append('file', file);
      const {code,data} = await planFileSetSampleTemplateFn(fd);
      if(code === 1){
        this.editForm.templateUrl = data;
        this.editForm.templateName = file.name;
      }
    },
    async uploadSubmit(){
      if(!this.editForm.filename){
        this.$message.error('请输入附件名称');
        return;
      }
      if(this.editForm.filename.length > 50){
        this.$message.error('附件名称不能超过50个字符');
        return;
      }
      if(!this.editForm.fileType1 && !this.editForm.fileType2 && !this.editForm.fileType3){
        this.$message.error('请选择附件格式');
        return;
      }
      if(this.editForm.fileRemark.length > 200){
        this.$message.error('附件说明不能超过200个字符');
        return;
      }
      if(!this.editForm.filesize){
        this.$message.error('请设置上传附件大小');
        return;
      }
      if(!/^\d+$/.test(this.editForm.filesize)){
        this.$message.error('附件大小只能为数字');
        return;
      }
      if(this.editForm.filesize>10){
        this.$message.error('附件大小不能超过10M');
        return;
      }
      let fileext = '';
      if(this.editForm.fileType1){
        fileext = 'pdf,';
      }
      if(this.editForm.fileType2){
        fileext += 'jpg,jpeg,png,';
      }
      if(this.editForm.fileType3){
        fileext += 'doc,docx,';
      }
      fileext = fileext.slice(0, -1);
      this.editForm.planId = this.planId;
      let params = {
        fileName: this.editForm.filename,
        fileExt: fileext,
        fileSize: this.editForm.filesize*1024,
        fileRemark: this.editForm.fileRemark,
        required: this.editForm.required,
        sampleUrl: this.editForm.sampleUrl,
        templateUrl: this.editForm.templateUrl,
        agentCode: this.editForm.agentCode,
      }
      if(this.editForm.editFlag){
        params.id = this.editForm.id;
      }else{
        params.planId = this.planId;
      }
      const submitFn = this.editForm.editFlag ? planFileSetModifyFn : planFileSetAddFn;
      const { code } = await submitFn(params);
      if (code === 1) {
        this.editForm.editFlag ? this.$message.success("编辑成功！") : this.$message.success("新增成功！");
        this.getList();
      }
      this.addFileFlag = false;
    },
    showSampleUrl(row){
      window.open(row.sampleUrl);
    },
    showTemplateUrl(row){
      window.open(row.templateUrl);
    },
  }
}
</script>

<style scoped lang="less">
.mainForm {
  /deep/ .el-form-item__content {
    .el-radio-group {
      padding-top: 8px;
      box-sizing: border-box;
      margin: auto;
    }
  }
  /deep/ .el-form-item__label {
    display: inline-block;
    padding: 0!important;
    width: 200px;
  }
  /deep/ .el-form-item {
    display: flex;
    align-items: center;
    .el-form-item__label{
      text-align: right;
    }

  }
}
.machineTip{
  color: #F56C6C;
  margin-left: 14px;
}
// 开始
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
  padding: 5px;
}
.el-upload__tip{
  font-size: 13px;
  line-height: 25px;
}
.fileListContent{
  margin-top: 10px;
  padding: 5px;
  line-height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;
}
/deep/ .shortInput{
  width: 80px;
  .el-input__inner{
    width: 80px;
  }
}
.upload-template-item {
  align-items: flex-start !important;
  /deep/ .el-form-item__label {
    padding-top: 8px !important;
  }
}
</style>